// Español
import globalEs from "./es/global.json";
import residentsEs from "./es/residents.json";
import platesEs from "./es/plates.json";
import tagsEs from "./es/tags.json";
import dashEs from "./es/dashboard.json";
import voteEs from "./es/vote.json";
import surveyEs from "./es/survey.json";
import cashEs from "./es/cash.json";
import bankEs from "./es/bank.json";
import activosEs from "./es/assets.json";
import transferEs from "./es/transfer.json";
import logsEs from "./es/logs.json";
import movesEs from "./es/moves.json";
import groupsEs from "./es/groups.json";
// English
import globalEn from "./en/global.json";
import residentsEn from "./en/residents.json";
import platesEn from "./en/plates.json";
import tagsEn from "./en/tags.json";
import dashEn from "./en/dashboard.json";
import voteEn from "./en/vote.json";
import surveyEn from "./en/survey.json";
import cashEn from "./en/cash.json";
import bankEn from "./en/bank.json";
import activosEn from "./en/assets.json";
import transferEn from "./en/transfer.json";
import logsEn from "./en/logs.json";
import movesEn from "./en/moves.json";
import groupsEn from "./en/groups.json";

export const resources = {
  es: {
    global: globalEs,
    residents: residentsEs,
    plates: platesEs,
    tags: tagsEs,
    dash: dashEs,
    vote: voteEs,
    survey: surveyEs,
    cash: cashEs,
    bank: bankEs,
    assets: activosEs,
    transfer: transferEs,
    logs: logsEs,
    moves: movesEs,
    groups: groupsEs,
  },
  en: {
    global: globalEn,
    residents: residentsEn,
    plates: platesEn,
    tags: tagsEn,
    dash: dashEn,
    vote: voteEn,
    survey: surveyEn,
    cash: cashEn,
    bank: bankEn,
    assets: activosEn,
    transfer: transferEn,
    logs: logsEn,
    moves: movesEn,
    groups: groupsEn,
  },
};
